export const register = {
    lang: {
        en: 'EN',
        my: 'BM',
        ch: 'CH'
    },
    title: 'REGISTER',
    type: {
        name: 'ID Type',
        placeholder: 'ID Type',
        required: 'ID Type',
        too_short: '',
        invalid: '',
        defaultText: 'ID Type',
    },
    id_type: [
        { text:"NRIC", value: "NRIC" },
        { text:"Passport", value: "Passport"  },
        { text:"Army ID", value: "Army ID"  },
        { text:"Police ID", value: "Police ID"  },
    ],
    firstname: {
        name: 'Name as per ',
        placeholder: '',
        required: 'Name as per',
        too_short: '',
        invalid: '',
    },
    no: {
        name: ' No.',
        placeholder: ' No.',
        required: ' No.',
        too_short: '',
        invalid: '',
    },
    title_gender: 'Gender',
    gender_list: [
        {
            text: 'Male',
            value: 'Male',
        },
        {
            text: 'Female',
            value: 'Female',
        },
    ],
    male: "Male",
    female: "Female",
    race: {
        name: 'Race',
        placeholder: 'Race',
        required: 'Race',
        too_short: '',
        invalid: '',
    },
    flag: [
        { text:"malaysia", value: 0 },
        { text:"singapore", value: 1 },
    ],
    contactNumber: {
        name: 'Mobile Number',
        placeholder: 'Mobile Number',
        required: '',
        too_short: '',
        invalid: '',
    },
    email: {
        name: 'Email',
        placeholder: 'Email',
        required: '',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: '',
        too_short: '',
        invalid: '',
    },
    confirm_password: {
        name: 'Confirm Password',
        placeholder: 'Confirm Password',
        required: '',
        too_short: '',
        invalid: '',
        match: '',
    },
    text_refer: 'Refer Friend (Optional)',
    refer_friend: {
        name: 'Referral Code',
        placeholder: 'Referral Code',
        required: '',
        too_short: '',
        invalid: '',
    },
    select_img: 'select image',
    pdpa: {
        agree: 'I have read & agree to',
        terms: ' Terms & Conditions ',
        and: 'and',
        privacy: ' Privacy Policy'

    },
    btn: 'Continue',
    birthdate: {
        name: 'วันเกิด',
        placeholder: 'วันเกิด',
        required: '',
        too_short: '',
        invalid: '',
    },
    otp_title: "Please fill in OTP number",
    otp_send_to: "OTP has been sent to mobile no.",
    otp_refcode: "Ref code : ",
    resend_otp: "Resend OTP code in ",
    send_otp_again: "Resend OTP",
    verify: "Confirm",
    invalid_code: "Invalid OTP number entered. Please try again or contact BHPetrol Customer Service 03-7719 9499",
    error_code: "Error Code : ",
    modal_success_title: "Successfully Registered",
    modal_success_subtitle: "You can login eCard Application using the mobile number registered just now.",
    download_app: "Download eCard Application",

    validate: {
        input_id: 'Invalid {0} Number. Please re-enter a correct {1} Number.',
        input_invalid: 'Invalid {0} entered. Please try again.',
        password: 'Your password must be at least 6 characters and not more than 16 characters. Your password must not contain space or special character. Example:Bhp123.',
        not_match: 'Your Password and Confirm Password do not match. Please key in again.',
        btn: 'Close'
    },
    valid_mobile: 'Mobile No.',
    valid_email: 'Email',

    error: {
        title: "Error",
        err_id: {
            msg: "ID has been registered. Please contact BHPetrol Customer Service Center for further assistance at 03-7719 9499."
        },
        err_number: {
            msg: "Contact number has been registered. Please contact BHPetrol Customer Service Center for further assistance at 03-7719 9499."
        },
        err_dup_email: {
            msg: "Email has been registered. Please contact BHPetrol Customer Service Center for further assistance at 03-7719 9499."
        },
        err_refcode_full: {
            msg: "Referral code limit has been reached."
        },
        err_invalid_refcode: {
            msg: "Invalid referral code."
        },
    },
    register_error_title: "Error",
    register_error_msg: "Description: Register unsuccessful. Please call BHPetrol Customer Service Centre for assistance at 03-7719 9499",

}
